import React from 'react';
import {
  Heading,
  IconButton,
  Squish,
  Stack,
  SvgX,
} from '@grubhubprod/gh-cookbook-react';

interface DialogHeaderProps {
  onDismiss: () => void;
  heading: string;
}

export function DialogHeader({
  onDismiss,
  heading,
}: DialogHeaderProps): JSX.Element {
  return (
    <Squish inset="sm">
      <Stack y="x-sm">
        <IconButton
          variant="tertiary"
          flavor="default"
          buttonSize="small"
          icon={SvgX}
          onClick={onDismiss}
          aria-label="Close"
        />
      </Stack>
      <Heading variant="h1" textAlign="start">
        {heading}
      </Heading>
    </Squish>
  );
}
